var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showMenu)?_c('b-list-group',{attrs:{"flush":""}},_vm._l((_vm.routes),function(route){return _c('b-list-group-item',{key:route.path,attrs:{"to":route.path,"active":_vm.actualRoute == route.name}},[_c('b-icon',{attrs:{"icon":_vm.getIcons(route.name)}}),_vm._v(" "+_vm._s(route.name)+" ")],1)}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }